import { Copy, MessageCircle } from "lucide-react";
import { toast } from "sonner";

export function publicTrackingUrl(code) {
  return `${window.location.origin}/track/${encodeURIComponent(String(code || "").trim().toUpperCase())}`;
}

export default function ShareTrackingActions({ code, label = "shipment", testId, compact = false }) {
  const url = publicTrackingUrl(code);
  const text = `Track ${label} ${String(code || "").toUpperCase()}: ${url}`;
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      toast.success("Tracking link copied");
    } catch {
      toast.error("Copy failed — please copy the tracking link manually");
    }
  };
  const cls = compact
    ? "flex items-center justify-center rounded-lg p-2 text-slate-400 transition-colors hover:bg-slate-100 hover:text-shipany-blue"
    : "flex items-center gap-2 rounded-xl border border-slate-200 px-4 py-2.5 text-sm font-bold text-slate-600 transition-colors hover:bg-slate-50";
  return (
    <div className="flex items-center gap-1.5" data-testid={testId}>
      <button type="button" onClick={copy} title="Copy tracking link" data-testid={`${testId}-copy`} className={cls}>
        <Copy className="h-4 w-4" />{!compact && "Copy link"}
      </button>
      <a href={`https://wa.me/?text=${encodeURIComponent(text)}`} target="_blank" rel="noreferrer" title="Share tracking on WhatsApp" data-testid={`${testId}-whatsapp`} className={cls}>
        <MessageCircle className="h-4 w-4 text-emerald-500" />{!compact && "WhatsApp"}
      </a>
    </div>
  );
}
